import React from 'react';

import {FbtBundleConfigContext} from '@udemy/react-discovery-units';
import {useFeatures} from '@udemy/react-experimentation-provider';

import {REDESIGNED_FBT_COURSE_BUNDLE_AFTER_ADDTOCART_EVENT} from 'src/lib/experimentation-constants';

/**
 * Feeds the redesigned "Frequently Bought Together" bundle config into the shared cart success modal
 * (built internally by `@udemy/react-discovery-units` / `ShoppingClient`, so config flows through
 * context rather than props). Gated behind the `redesigned_fbt_course_bundle_after_addtocart_event`
 * experiment; when the variant is off, all three flags stay `false` and behavior is unchanged.
 *
 * Must render inside `ExperimentationProvider` (so `useFeatures` resolves) and be an ancestor of
 * wherever the add-to-cart success modal mounts.
 */
export const FbtBundleConfigProvider = ({children}: {children: React.ReactNode}) => {
    const {featureVariantAssignments} = useFeatures([
        REDESIGNED_FBT_COURSE_BUNDLE_AFTER_ADDTOCART_EVENT,
    ]);
    const on =
        featureVariantAssignments.get(REDESIGNED_FBT_COURSE_BUNDLE_AFTER_ADDTOCART_EVENT)
            ?.configuration?.showRedesignedFBTCourseBundle ?? false;

    return (
        <FbtBundleConfigContext.Provider
            value={{
                excludeAddedCourseFromBundle: on, // drop the just-added course (2 courses, not 3)
                showPerCardAddToCart: on, // per-card ATC button + horizontal product-card layout
                hideRelatedLabelsList: on, // remove the related-topics pills
                wideSuccessModal: on, // wider modal (maps to CartSuccessModal size='wide')
            }}
        >
            {children}
        </FbtBundleConfigContext.Provider>
    );
};
